import {SalesDemoCategory} from './api/frontendService/entities';

export const salesDemoCategoryToHeader = (category: SalesDemoCategory) => {
  switch (category) {
    case SalesDemoCategory.ADDITIONAL_DEMOS:
      return 'Additional Demos';
    case SalesDemoCategory.EMBEDDED:
      return 'SHOULD_NOT_BE_SHOWN';
    case SalesDemoCategory.INNOVATION:
      return 'Always Innovative';
    case SalesDemoCategory.EASE_OF_USE:
      return 'Ease of Use';
    case SalesDemoCategory.PARTNERS:
      return 'Partners';
    case SalesDemoCategory.HIGHER_QUALITY:
      return 'Higher Quality';
    case SalesDemoCategory.MONETIZATION:
      return 'Monetization';

    default:
      return 'UNKNOWN_SALES_DEMO_CATEGORY';
  }
};
